import { render } from 'react-dom';
import App from './App';

const renderApp = (containerId: string, prefix: string, mfeUrl: string) => {
  const rootElement = document.getElementById(containerId);
  render(
    <App
      accessToken=""
      apiServerUrl=""
      client=""
      jwtToken=""
      patientId={0}
      uid=""
      prefix={prefix}
      mfeUrl={mfeUrl}
    />,
    rootElement
  );
};

window.renderScreeners = renderApp;
